module.exports = __webpack_public_path__ + "img/2-about.b9502fb6.jpg";